const __WEBPACK_NAMESPACE_OBJECT__ = ReactDOM19Client;